import { Component, EventEmitter, OnDestroy } from '@angular/core';

@Component({ template: '' })
export class DestroyComponent implements OnDestroy {
  destroy$ = new EventEmitter<boolean>();

  ngOnDestroy(): void {
    this.destroy$.emit(true);
  }
}
